import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-cream py-20 sm:py-28" data-id="element-218" data-mp="3hq073mlwlh6x">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-219" data-mp="3cs8h4y4tk55d">
        <div className="mx-auto max-w-3xl text-center" data-id="element-220" data-mp="3cqnlf56rqg5x">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-221" data-mp="38sg7ei3ovsyf">Real customer stories</p>
          <h2 className="mt-5 font-serif text-4xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-222" data-mp="9b02so9avnfe">
            When you know what alternatives to try, renovating <em className="text-gold" data-id="element-223" data-mp="bladj9kp2s9">doesn't feel so complicated.</em>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-body" data-id="element-224" data-mp="dfwv20ht2yg">
            Real experiences from people who started looking at their homes differently before tearing things out, replacing everything, or spending more than necessary.
          </p>
        </div>

        <ul className="mt-14 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-225" data-mp="2g1y5hkepbxml">
          {testimonials.map(t => <li key={t.name} className="flex flex-col" data-id="element-226" data-mp="fx91etl8cazm">
              <img src={t.photo} alt={t.photoAlt} loading="lazy" className="aspect-square w-full rounded-[4px] object-cover" data-id="element-227" data-mp="kyok4ezxq5eu" />
              <div className="mt-5 flex text-gold" aria-label="5 out of 5 stars" data-id="element-228" data-mp="6y5f7gqrnfgw">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-229" data-mp="3tei3r2pkbx04" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 font-serif text-[17px] italic leading-relaxed text-ink" data-id="element-230" data-mp="1zu6xag4dd0s">"{t.quote}"</blockquote>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-231" data-mp="3keuz881jeb2u">
                <img src={t.avatar} alt={t.name} loading="lazy" className="h-11 w-11 shrink-0 rounded-full object-cover object-top ring-2 ring-cream" data-id="element-232" data-mp="3oene12hixdgn" />
                <div className="leading-tight" data-id="element-233" data-mp="3ag5qb4rmc0yq">
                  <p className="text-sm font-bold text-ink" data-id="element-234" data-mp="3ff0d0hspi9o4">{t.name}</p>
                  <p className="mt-1 flex items-center gap-1 text-xs font-medium text-body" data-id="element-235" data-mp="1ky8kyd8bhkc3">
                    <BadgeCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-236" data-mp="1l03ay5yg42n1" />
                    Verified Buyer
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}